import React from "react";
import "./Header.css";
import logo from "../logo/logo.svg";
export default class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = { date: new Date(), day: new Date() };
  }

  componentDidMount() {
    this.timerID = setInterval(() => this.tick(), 1000);
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }
  tick() {
    this.setState({
      date: new Date(),
      day: new Date(),
    });
  }
  render() {
    return (
      <>
        <div class="header_wrapper">
          <h1 class="header_iconClock">
            <a href="index.html">
              <img class="logo" src={logo} alt="headerlogo" />
            </a>
            <h2 class="header_clock">
              {this.state.day.toLocaleDateString()}&ensp;
              {this.state.date.toLocaleTimeString()}
            </h2>
          </h1>
        </div>
      </>
    );
  }
}
